document.addEventListener("DOMContentLoaded", function(e) {
	document.addEventListener('click', function (event) {
		if (!event.target.matches('#expand-featured')) return;		
		
		event.target.parentNode.classList.toggle('featured-show');
	}, false);
});